module.exports = __webpack_public_path__ + "img/logo.5a831247.png";